import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import Styles from "./styles.module.css";
// Tile images import
import homeTile from "../../Assets/home/main-tile.jpg";
//epictiles
import solutTile from "../../Assets/home/poster-solute.jpg";
import beachesTile from "../../Assets/home/poster-beaches.jpg";
import orthodoxTile from "../../Assets/home/poster-orthodox.jpg";
import balconiesTile from "../../Assets/home/poster-balconies.jpg";
import landscapeTile from "../../Assets/home/poster-landscape.jpg";
import generationukraineTile from "../../Assets/home/poster-generationukraine.jpg";
import dovecotesTile from "../../Assets/home/poster-dovecotes.jpg";
//epictiles end

import farmakTile from "../../Assets/home/farmak-commercial-tile.jpg";
import farmakTileV2 from "../../Assets/home/farmak-commercial-tile-2.jpg";
import politicalTile from "../../Assets/home/political-tile.jpg";
import harveastTile from "../../Assets/home/harveast-tile.jpg";
import dekronTile from "../../Assets/home/dekron-tile.jpg";
import politicalTileV2 from "../../Assets/home/political-tile-2.jpg";
import elephantsTile from "../../Assets/home/elephants-tile.jpg";
import heForShe from "../../Assets/home/he-for-she-tile.jpg";
import tourismTile from "../../Assets/home/tourism-tile.jpg";
import concordTile from "../../Assets/home/concord-group-tile.jpg";
import gusovskyTile from "../../Assets/home/gusovsky-tile.jpg";
import premierFoodTile from "../../Assets/home/premier-food-tile.jpg";
import holosuyTile from "../../Assets/home/holosuy-tile.jpg";
import OsnovyTile from "../../Assets/home/osnovy-promo-tile.jpg";
import holosuyVoteTile from "../../Assets/home/holosuy-vote-tile.jpg";
import holosuyShchurTile from "../../Assets/home/holosuy-shchur-tile.jpg";
import acerTile from "../../Assets/home/acer-tile.jpg";
import TimechangeTile from "../../Assets/home/TimesChange-tile.jpg";
import Germanising101Tile from "../../Assets/home/Germanaising-tile.jpg";
import PlaylikeagirlTile from "../../Assets/home/PLG-tile.jpg";
import PokemonTile from "../../Assets/home/Pokemon-tile.jpg";


// import modernismCasestudyTile from '../../Assets/home/modernism-casestudy-tile.jpg';
// import balconyTrailerTile from '../../Assets/home/balconyTrailerTile.jpg';

// Tile Hover GIFs import
import Farmak_labHover from "../../Assets/home/hover/Farmak_lab.gif";
import Farmak_81_18Hover from "../../Assets/home/hover/Farmak_81_18.gif";
import concordHover from "../../Assets/home/hover/Concord.gif";
import The_elephantsHover from "../../Assets/home/hover/The_elephants.gif";

import LeshenkoHover from "../../Assets/home/hover/Leshenko.gif";
import HarveastHover from "../../Assets/home/hover/Harveast.gif";
import DecronHover from "../../Assets/home/hover/Decron.gif";
import ZalishukHover from "../../Assets/home/hover/Zalishuk.gif";

import MrGrillHover from "../../Assets/home/hover/MrGrill.gif";
import HeForSheHover from "../../Assets/home/hover/HeForShe.gif";
import ChernihivHover from "../../Assets/home/hover/Chernihiv.gif";
import GusovskyHover from "../../Assets/home/hover/Gusovsky.gif";
import HolosuyHover from "../../Assets/home/hover/Holosuy.gif";
import Osnovy_publishingHover from "../../Assets/home/hover/Osnovy_publishing.gif";
import HolosuyVote from "../../Assets/home/hover/HolosuyVote.gif";
import HolosuyShchur from "../../Assets/home/hover/HolosuyShchur.gif";
import Acer from "../../Assets/home/hover/Acer.gif";

import LandscapeHover from "../../Assets/home/hover/Acer.gif";

import TCHover from "../../Assets/home/hover/TCcovergif.gif";
import GerHover from "../../Assets/home/hover/GER_cover.gif";
import PLGHover from "../../Assets/home/hover/Playlikeagirl.gif";
import PokemonHover from "../../Assets/home/hover/Pokemon.gif";



// import balconyTrailer from '../../Assets/home/hover/balconyTrailer.gif';
// import modernismCaseStudy from '../../Assets/home/hover/modernismCaseStudy.gif';

// Videos imports
import mainVideo from "../../Assets/home/videos/Web_cover_full_HD.mp4";
import Tile from "./Tile";
import EpicTile from "./EpicTitle";
import VideoTile from "./VideoTile";

export default class Home extends Component {
  constructor(props: any) {
    super(props);
  }
  render() {
    return (
      <>
                       {/* Main Video Tile */}
        <Container fluid className={Styles.container}>
          <Row noGutters>
            <Col xs="12" className={Styles.mainTile}>
              <VideoTile
                video={mainVideo}
                header="The Basement (working title Basement 341)"
                text="in post-production"
                link="/details/24"
              />
            </Col>
          </Row>
                    {/* 2 regular tiles row
          <Row noGutters className={Styles.tiles}>
            <Col xs={{ size: 6, offset: 0 }}>
              <Tile
                img={farmakTile}
                hoverImg={Farmak_labHover}
                header="Farmak"
                text="Commercial"
                link="/details/2"
              />
            </Col>
            <Col xs={{ size: 6, offset: 0 }}>
              <Tile
                img={farmakTileV2}
                hoverImg={Farmak_81_18Hover}
                header="81/18"
                text="Commercial"
                link="/details/3"
              />
            </Col>
          </Row> */}
                      {/* Right Poster with Balconies row */}

                      {/* Row with two epics: Generation Ukraine and Dovecotes */}
                      <Row noGutters className={Styles.tiles}>
            <Col xs="6">
              <Tile
                img={generationukraineTile}
                header=""
                text=""
                link="/details/29"
                isBig
              />
            </Col>
            <Col xs="6">
              <Tile
                img={dovecotesTile}
                header=""
                text=""
                link="/details/30"
                isBig
              />
            </Col>
          </Row>

                              {/* 2 regular tiles row*/}
                              <Row noGutters className={Styles.tiles}>
            <Col xs={{ size: 6, offset: 0 }}>
              <Tile
                img={TimechangeTile}
                hoverImg={TCHover}
                header="Times Change"
                text="in development"
                link="/details/25"
              />
            </Col>
            <Col xs={{ size: 6, offset: 0 }}>
              <Tile
                img={Germanising101Tile}
                hoverImg={GerHover}
                header="Germanising 101"
                text="in development"
                link="/details/26"
              />
            </Col>
          </Row>

                                        {/* 2 regular tiles row*/}
                                        <Row noGutters className={Styles.tiles}>
            <Col xs={{ size: 6, offset: 0 }}>
              <Tile
                img={PlaylikeagirlTile}
                hoverImg={PLGHover}
                header="Play like a girl"
                text="in development"
                link="/details/27"
              />
            </Col>
            <Col xs={{ size: 6, offset: 0 }}>
              <Tile
                img={PokemonTile}
                hoverImg={PokemonHover}
                header="Searching for Pokemon"
                text="in development"
                link="/details/28"
              />
            </Col>
          </Row>

          {/*
          <Row noGutters>
            <EpicTile
              tiles={[
                // {
                //   image: politicalTile,
                //   hoverImg: LeshenkoHover,
                //   header: "Serhiy Leshchenko",
                //   text: "Political campaign ad",
                //   link: "/details/4",
                // },
                {
                  image: harveastTile,
                  hoverImg: HarveastHover,
                  header: "Harveast | Director's cut",
                  text: "Commercial",
                  link: "/details/5",
                },
                {
                  image: dekronTile,
                  hoverImg: DecronHover,
                  header: "Space Coin | Director's cut",
                  text: "Commercial",
                  link: "/details/6",
                },
                {
                  image: elephantsTile,
                  hoverImg: The_elephantsHover,
                  header: "The Elephants | Friend",
                  text: "Music video",
                  link: "/details/9",
                },
                {
                image: holosuyTile,
                hoverImg: HolosuyHover,
                header: "Holosuy! | Don’t vote!",
                text: "Commercial",
                link: "/details/15"
                },
                // {
                //   image: heForShe,
                //   hoverImg: HeForSheHover,
                //   header: "HeForShe l Women’s Voices",
                //   text: "Commercial",
                //   link: "/details/10",
                // },

                // {
                //   image: politicalTileV2,
                //   hoverImg: ZalishukHover,
                //   header: "Svitlana Zalishchuk",
                //   text: "Political campaign ad",
                //   link: "/details/7",
                // },
              ]}
              epic={{
                image: balconiesTile,
                header: "",
                text: "",
                link: "/details/1",
              }}
              isLeft={false}
            />
          </Row>
            */}
                                {/* Row with two epics: Landscape architecture and Balconies */}
                                <Row noGutters className={Styles.tiles}>
            <Col xs="6">
              <Tile
                img={landscapeTile}
                header=""
                text=""
                link="/details/22"
                isBig
              />
            </Col>
            <Col xs="6">
              <Tile
                img={balconiesTile}
                header=""
                text=""
                link="/details/1"
                isBig
              />
            </Col>
          </Row>




          
                      {/* Left Poster with Landscape */}
          {/*<Row noGutters>
            <EpicTile
              tiles={[
                {
                  image: tourismTile,
                  hoverImg: ChernihivHover,
                  header: "Chernihiv City Promo",
                  text: "Commercial",
                  link: "/details/11",
                },
                {
                  image: concordTile,
                  hoverImg: concordHover,
                  header: "Spark",
                  text: "Commercial",
                  link: "/details/12",
                },
                // {
                //   image: gusovskyTile,
                //   hoverImg: GusovskyHover,
                //   header: "Serhiy Gusovsky",
                //   text: "Political campaign ad",
                //   link: "/details/13",
                // },

                // {
                //   image: premierFoodTile,
                //   hoverImg: MrGrillHover,
                //   header: "Premier food | Director's cut",
                //   text: "Commercial",
                //   link: "/details/14",
                // },

                {
                  image: OsnovyTile,
                  hoverImg: Osnovy_publishingHover,
                  header: "Osnovy Publishing",
                  text: "Commercial",
                  link: "/details/16",
                },
                
                {
                  image: holosuyVoteTile,
                  hoverImg: HolosuyVote,
                  header: "Holosuy! | Why vote?",
                  text: "Social media ads",
                  link: "/details/17",
                },

              ]}
              epic={{
                image: landscapeTile,
                header: "",
                text: "",
                link: "/details/22",
              }}
              isLeft={true}
            />
          </Row>

            */}
          
                              {/* 2 regular tiles row
                              <Row noGutters className={Styles.tiles}>
            <Col xs={{ size: 6, offset: 0 }}>
              <Tile
                img={holosuyTile}
                hoverImg={HolosuyHover}
                header="Holosuy! | Don’t vote!"
                text="Commercial"
                link="/details/15"
              />
            </Col>
            <Col xs={{ size: 6, offset: 0 }}>
              <Tile
                img={holosuyVoteTile}
                hoverImg={HolosuyVote}
                header="Holosuy! | Why vote?"
                text="Social media ads"
                link="/details/17"
              />
            </Col>
          </Row> */}

          
                                    {/* Row with two epics: Solut and Beaches */}
          <Row noGutters className={Styles.tiles}>
            <Col xs="6">
              <Tile
                img={solutTile}
                header=""
                text=""
                link="/details/8"
                isBig
              />
            </Col>
            <Col xs="6">
              <Tile
                img={beachesTile}
                header=""
                text=""
                link="/details/19"
                isBig
              />
            </Col>
          </Row>

                      {/* Row with one epic: Orthodox */}
          <Row noGutters className={Styles.tiles}>
            <Col xs="6">
              <Tile
                img={orthodoxTile}
                header=""
                text=""
                link="/details/20"
                isBig
              />
            </Col>
          </Row>
                      {/* 2 regular tiles row, Acer*/}
          {/* <Row noGutters className={Styles.tiles}>
            <Col xs="6">
              <Tile
                img={acerTile}

                header="Acer & Osnovy Publishing"
                text="Commercial"
                link="http://google.com/"
              />
            </Col>

          </Row> */}



{/* Reference Row with two epics . DONT DELETE! */}
          {/* <Row noGutters className={Styles.tiles}>
            <Col xs="6">
              <Tile
                img={solutTile}
                hoverImg={The_elephantsHover}
                header="The Elephants | Friend"
                text="Music video"
                link="/details/9"
                isBig
              />
            </Col>
            <Col xs="6">
              <Tile
                img={beachesTile}
                hoverImg={HeForSheHover}
                header="HeForShe l Women’s Voices"
                text="Commercial"
                link="/details/10"
                isBig
              />
            </Col>
          </Row>



          
          {/* <Row noGutters className={Styles.tiles}>
                        <Col xs="6"><Tile img={holosuyTile} hoverImg={HolosuyHover} header="Holosuy! | Don’t vote!" text="Commercial" link="/details/15"/></Col>
                        <Col xs="6"><Tile img={OsnovyTile} hoverImg={Osnovy_publishingHover}header="Osnovy Publishing" text="Commercial" link="/details/16"/></Col>
                        <Col xs="6"><Tile img={holosuyVoteTile} hoverImg={HolosuyVote} header="Holosuy! | Why vote?" text="Social media ads" link="/details/17"/></Col>
                        <Col xs="6"><Tile img={holosuyShchurTile} hoverImg={HolosuyShchur}header="Holosuy! | Michael Shchur" text="Commercial" link="/details/18"/></Col>
                    </Row> */}
        </Container>
      </>
    );
  }
}
